import React from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect } from 'react-redux'
import { userTokenSelector } from 'Store/customer/selector'
import { RootState } from 'Store'
import { selectEventDashboard } from 'Store/dashboard/selector'
import { LoadingView } from 'Components/modal'
import { Col, Row, Card } from 'antd'
import { MyTheme } from 'Components/common/Theme'
import styled from 'styled-components'
import { YoutubeFilled } from '@ant-design/icons'
import { themeConfig } from 'config'
const { Meta } = Card

type Props = {} & ReduxProps

const Welcome: React.FunctionComponent<Props> = props => {
  const { event } = props

  const video = [
    {
      title: 'วิธีการนำสินค้าเข้าระบบ',
      src: 'https://www.youtube.com/embed/k45w-pvycxo',
    },
    {
      title: 'วิธีการเพิ่มสินค้า',
      src: 'https://www.youtube.com/embed/fl_91NN6eG0',
    },
    {
      title: 'วิธีการดูรายการคำสั่งซื้อมาใหม่',
      src: 'https://www.youtube.com/embed/nKryThhctJM',
    },
    {
      title: 'วิธีดูข้อมูลบน Dashboard',
      src: 'https://www.youtube.com/embed/_OgnsCNymRg',
    },
  ]

  const showHowto = themeConfig?.component?.staffHowTo

  return (
    <HomePageLayout selected="" title={themeConfig.title.fullName}>
      <LoadingView isShow={event.IsLoading} />
      <Row justify="start">
        <Col>
          <WelcomeText>ยินดีต้อนรับ</WelcomeText>
        </Col>
      </Row>
      {showHowto && (
        <>
          <Row justify="center">
            <Col>
              <Title>
                <YoutubeFilled /> วิธีการใช้งาน {themeConfig.title.fullName}
              </Title>
            </Col>
          </Row>
          <VideoWrapper>
            <Row gutter={[32, 16]}>
              {video.map((item, index) => {
                return (
                  <Col lg={8} md={12} xs={24} key={index}>
                    <VideoIFrame
                      src={item.src}
                      title={item.title}
                      frameBorder={0}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></VideoIFrame>
                  </Col>
                )
              })}
            </Row>
          </VideoWrapper>
        </>
      )}
    </HomePageLayout>
  )
}

const WelcomeText = styled.p`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.drakGrey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
`

const Title = styled.div`
  margin: 20px 0;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
`

const VideoWrapper = styled.div`
  @media only screen and (min-width: 990px) {
    padding: 20px 100px;
  }

  .ant-card-body {
    padding: 0;
  }
`

const VideoIFrame = styled.iframe`
  width: 100%;
  height: 200px;
  @media only screen and (min-width: 1140px) {
    height: 300px;
  }

  @media only screen and (min-width: 720px) {
    height: 220px;
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    token: userTokenSelector(state),
    event: selectEventDashboard(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(Welcome)
